var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerifiedPremium = function SvgVerifiedPremium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#verified_premium_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC800",
    d: "M12.5 24c-.53 0-1.056-.114-1.536-.332a3.72 3.72 0 0 1-2.968-.795 3.72 3.72 0 0 1-2.66-1.536 3.72 3.72 0 0 1-2.173-2.173 3.73 3.73 0 0 1-1.536-2.66 3.72 3.72 0 0 1-.795-2.968 3.73 3.73 0 0 1 0-3.072 3.73 3.73 0 0 1 .795-2.968 3.72 3.72 0 0 1 1.536-2.66 3.73 3.73 0 0 1 2.173-2.173 3.73 3.73 0 0 1 2.66-1.536 3.73 3.73 0 0 1 2.968-.795 3.73 3.73 0 0 1 3.072 0 3.72 3.72 0 0 1 2.968.795 3.73 3.73 0 0 1 2.66 1.536 3.72 3.72 0 0 1 2.173 2.173 3.73 3.73 0 0 1 1.536 2.66 3.72 3.72 0 0 1 .795 2.968 3.73 3.73 0 0 1 0 3.072 3.73 3.73 0 0 1-.795 2.968 3.72 3.72 0 0 1-1.536 2.66 3.73 3.73 0 0 1-2.173 2.173 3.73 3.73 0 0 1-2.66 1.536 3.72 3.72 0 0 1-2.968.795A3.7 3.7 0 0 1 12.5 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA400",
    d: "M12.5 0c.53 0 1.056.114 1.536.332a3.72 3.72 0 0 1 2.968.795 3.73 3.73 0 0 1 2.66 1.536 3.72 3.72 0 0 1 2.173 2.173 3.73 3.73 0 0 1 1.536 2.66 3.72 3.72 0 0 1 .795 2.968 3.73 3.73 0 0 1 0 3.072 3.73 3.73 0 0 1-.795 2.968 3.72 3.72 0 0 1-1.536 2.66 3.73 3.73 0 0 1-2.173 2.173 3.73 3.73 0 0 1-2.66 1.536 3.72 3.72 0 0 1-2.968.795A3.7 3.7 0 0 1 12.5 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#194E57",
    d: "M12.5 20.987a8.988 8.988 0 1 0 0-17.975 8.988 8.988 0 0 0 0 17.975"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003540",
    d: "M12.5 3.012c4.956 0 8.988 4.032 8.988 8.988s-4.032 8.987-8.988 8.987z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE66F",
    d: "M16.266 16.469H8.734a.7.7 0 0 1-.682-.533L6.546 9.911a.703.703 0 0 1 .997-.8l2.43 1.216 1.924-3.208a.703.703 0 0 1 1.206 0l1.924 3.208 2.43-1.215a.703.703 0 0 1 .997.8l-1.506 6.024a.7.7 0 0 1-.682.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC800",
    d: "M16.266 16.469c.322 0 .604-.22.682-.533l1.506-6.025a.703.703 0 0 0-.997-.8l-2.43 1.216-1.924-3.208a.7.7 0 0 0-.603-.34v9.69z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verified_premium_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgVerifiedPremium;